import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CaseTitleTooltip from '../tooltips/caseTitleTooltip/CaseTitleTooltip';
import '../../../../less/flashYellow.less';


class CaseNumberSelector extends Component {
  render() {
    const clsName = (this.props.showFlash) ? 'input-search x-closeable flash-yellow' : 'input-search x-closeable';

    return (
      <div className="form-item" style={{ display: 'inline-block', width: 'auto' }}>
        <label htmlFor="title-or-name">Case Title or Party Name: <CaseTitleTooltip /></label>
        <input type="search"
               maxLength="128"
               id="title-or-name"
               size="60"
               onChange={this.props.onChange}
               value={this.props.value}
               className={clsName} />
      </div>
    );
  }
}

CaseNumberSelector.defaultProps = {
  showFlash: false,
  value: '',
  onChange: () => null,
};

CaseNumberSelector.propTypes = {
  showFlash: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
};


export default CaseNumberSelector;



// WEBPACK FOOTER //
// ./src/components/search/FormElements/caseSelector/CaseTitleOrPartyNameSelectorOfCaseLookup.jsx